// import React, { memo, useCallback } from "react";
// import { Link } from "react-router-dom";
// import { useCart } from "../../context/CartContext";

// function CartItems({ item }) {
//   const { updateQuantity, removeItem } = useCart();

//   const {
//     _id,
//     thumbnail: image,
//     slug,
//     title,
//     variantName,
//     quantity,
//     price,
//     mrp,
//   } = item;

//   const numPrice = Number(price);
//   const numMrp = Number(mrp);

//   const handleRemove = useCallback(() => {
//     removeItem(_id);
//   }, [removeItem, _id]);

//   const handleQuantityChange = useCallback(
//     (delta) => {
//       const newQuantity = quantity + delta;
//       if (newQuantity < 1) return;

//       console.log(newQuantity);
//       updateQuantity(_id, newQuantity);
//     },
//     [updateQuantity, _id, quantity],
//   );

//   return (
//     <>
//       <div className="custom-cart-item d-flex border-bottom">
//         <div className="cart-item-image-wrapper">
//           <Link to={`/shop/${slug}`}>
//             <img src={image} className="cart-item-img me-3" alt="Cart Item" />
//           </Link>
//         </div>
//         <div className="flex-grow-1">
//           <div className="d-flex justify-content-between align-items-start">
//             <Link to={`/shop/${slug}`} className="cart-item-title">
//               {title}
//             </Link>
//             <i
//               className="icon icon-close remove fs-12"
//               onClick={handleRemove}
//             />
//           </div>
//           <div className="info-variant">{variantName}</div>
//           <p className="price-wrap text-sm fw-medium mb-0">
//             <span className="cart-item-price">
//               ₹{numPrice.toFixed(2)}/-
//             </span>
//             {!isNaN(numMrp) && numMrp > numPrice && (
//               <span className="old-price text-decoration-line-through text-dark-1">
//                 ₹{numMrp.toFixed(2)}/-
//               </span>
//             )}
//           </p>
//           <div>
//             <div className="d-flex justify-content-between align-items-center mt-2">
//               <div className="cart-bottom-row">
//                 <div className="qty-box">
//                   <button onClick={() => handleQuantityChange(-1)}>-</button>
//                   <span>{quantity}</span>
//                   <button onClick={() => handleQuantityChange(+1)}>+</button>
//                 </div>

//                 <span className="item-total">
//                   ₹{(price * quantity).toFixed(0)}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default memo(CartItems);




import React, { memo, useCallback } from "react";
import { Link } from "react-router-dom";
import { useCart } from "../../context/CartContext";

function CartItems({ item }) {
  const { updateQuantity, removeItem } = useCart();

  const {
    _id,
    thumbnail: image,
    slug,
    title,
    variantName,
    quantity,
    price,
    mrp,
  } = item;

  const numPrice = Number(price);
  const numMrp = Number(mrp);

  const handleRemove = useCallback(() => {
    removeItem(_id);
  }, [removeItem, _id]);

  const handleQuantityChange = useCallback(
    (delta) => {
      const newQuantity = quantity + delta;
      if (newQuantity < 1) return;
      updateQuantity(_id, newQuantity);
    },
    [updateQuantity, _id, quantity]
  );

  return (
    <div className="flex gap-3 pb-3 animate-fade-in">
      {/* Image */}
      <div className="w-[72px] h-[88px] flex-shrink-0 rounded-md overflow-hidden bg-neutral-100 border border-[#ebdcca]">
        <Link
          to={`/shop/${slug}`}
          style={{ textDecoration: "none" }}
        >
          <img
            src={image}
            alt={title || "Cart Item"}
            className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
          />
        </Link>
      </div>

      {/* Details */}
      <div className="flex-1">
        {/* Top Row */}
        <div className="flex justify-between items-start gap-2">
          <div className="flex-1 min-w-0">
            <Link
              to={`/shop/${slug}`}
              style={{ textDecoration: "none" }}
              className="font-serif text-[15px] text-neutral-900 hover:text-[#b85d19] transition-colors line-clamp-1"
            >
              {title}
            </Link>

            {variantName && (
              <div className="mt-0.5 text-[9px] uppercase tracking-[2px] text-neutral-500">
                {variantName}
              </div>
            )}
          </div>

          <button
            onClick={handleRemove}
            aria-label="Remove item"
            className="p-0.5 text-neutral-400 hover:text-red-500 transition-colors flex-shrink-0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
              />
            </svg>
          </button>
        </div>

        {/* Bottom Row */}
        <div className="flex justify-between items-center mt-2">
          <div className="flex items-center px-1.5 py-0.5 bg-white border border-[#ebdcca] rounded-full shadow-sm">
            <button
              onClick={() => handleQuantityChange(-1)}
              className="w-5 h-5 flex items-center justify-center text-sm font-medium text-neutral-600 hover:text-[#b85d19] transition-colors"
            >
              -
            </button>

            <span className="w-5 text-center text-xs font-semibold text-neutral-800">
              {quantity}
            </span>

            <button
              onClick={() => handleQuantityChange(1)}
              className="w-5 h-5 flex items-center justify-center text-sm font-medium text-neutral-600 hover:text-[#b85d19] transition-colors"
            >
              +
            </button>
          </div>

          <div className="flex items-baseline gap-1.5">
            {!isNaN(numMrp) && numMrp > numPrice && (
              <span className="text-[11px] text-neutral-400 line-through">
                ₹{numMrp.toFixed(0)}
              </span>
            )}

            <span className="font-serif text-base font-medium text-[#b85d19]">
              ₹{(numPrice * quantity).toFixed(0)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(CartItems);